<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :small='small'
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pager-count="5"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [20]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  //background: #FFEFAE;
  padding: 2rem 1.25rem;
}
.pagination-container.hidden {
  display: none;
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .pagination-container {
    padding: 1.5rem 1.25rem;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .pagination-container {
    padding: 1.5rem 1.25rem;
  }
}
::v-deep{
  .el-input__inner{
    background: #FFEFAE;
    border: 1px solid #FFEFAE;
  }
  .el-pagination--small .el-pagination__jump{
    display: none;
  }
  .el-pagination--small .el-pagination__sizes{
    display: none;
  }
  .el-pagination.is-background .el-pager li{
    background: white;
    color:#444444;
    border-radius: 50%;
    line-height: 2rem;
    height: 2rem;
    width: 2rem;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #F6C98E;
    color:#444444;
  }
}
</style>
